import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormErrorMessage, Text } from '@chakra-ui/core'
import { StyledFormControl, StyledFormLabel } from 'components/AdminConsole/commonUI/styles'
import useLocaleText from 'components/useLocaleText'
import { Zap } from 'lucide-react'
import { InputWithIcon } from 'components/AdminConsole/commonUI/InputWithIcon'
import { getNestedError, MAX_BTN_LENGTH } from '../utils'

interface BtnTextFieldProps {
  keyName: string
  label: string
  placeholder: string
  maxLength?: number
}
export const BtnTextField = ({ keyName, label, placeholder, maxLength = MAX_BTN_LENGTH }: BtnTextFieldProps) => {
  const { register, errors } = useFormContext()
  const t = useLocaleText(label, true)
  const t_placeholder = useLocaleText(placeholder, true)
  const error_ack_btn = useLocaleText('error_ack_btn', true)
  const error_ack_btn_max_length = useLocaleText('error_ack_btn_max_length', true)
  const error = getNestedError(errors, keyName)

  const validationRules = {
    required: error_ack_btn,
    maxLength: {
      value: maxLength,
      message: error_ack_btn_max_length,
    },
  }
  return (
    <StyledFormControl isInvalid={!!error}>
      <StyledFormLabel required>
        <Zap size={18} strokeWidth={2.5} />
        <Text>{t}</Text>
      </StyledFormLabel>
      <InputWithIcon name={keyName} ref={register(validationRules)} placeholder={t_placeholder} />
      <FormErrorMessage>{error?.message}</FormErrorMessage>
    </StyledFormControl>
  )
}
